import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import { Image } from 'semantic-ui-react';

import '../css/EnvelopeIcon.less';

import iconEnvelope from '../img/icon-envelope.svg';

import { SatCoreRegister } from '../SatCoreRegistry';

const EnvelopeIcon = observer((props = {}) => {
  const { /* managers */ } = useContext(MobXProviderContext);

  const { alt, hasNotifications } = props;

  return (
    <>
      <div className={classNames('EnvelopeIcon', {
        'with-notifications': hasNotifications
      })}>
        <Image alt={alt} src={iconEnvelope} />
      </div>
    </>
  );
});
export default EnvelopeIcon;

SatCoreRegister('EnvelopeIcon', EnvelopeIcon);
